<template>
  <li
    v-if="boxConfig.progressbar.kind === 'mask'"
    class="mask"
    style="left: 50px; opacity: 1; background: transparent"
    :style="getLiStyle()">
  </li>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  methods: {
    getStyle() {
      return this.stepStyle('progress-bullet-active');
    },
    getLiStyle() {
      const kind = this.boxConfig.progressbar.kind;
      const styles = this.getStyle();

      if (kind === 'mask') {
        return { borderColor: styles.borderColor };
      }

      return {};
    },
  },
  computed: mapGetters({
    boxConfig: 'boxConfig',
    stepStyle: 'stepStyle',
  }),
};
</script>



/** WEBPACK FOOTER **
 ** Mask.vue?4e092167
 **/